// extracted by mini-css-extract-plugin
export default {"titshare":"index_titshare_5BBbY","shareBox":"index_shareBox_NPMpp clearfix","boxhidden":"index_boxhidden_u-Wef"};